import { authorizedNetworkAiFetch } from 'app/axios/network'
import {
  CreateWLANBody,
  UpdateWLANBody,
  EnableWLANBody,
  OrgTemplates,
  UpdateOrgRFTemplate,
  SiteWlan,
  SitePSKs,
  UpdateSitePSKs,
  OrgAdminInvite,
  RemoveAdmin,
  DeleteOrgTemplate,
  OptimizeRadios,
} from './types'

export interface createOrGetNetworkHomeBody {
  homeId: string
  forceCreate: boolean
  name?: string
  address?: string
  timezone?: string
  country_code?: string
  latlng?: {
    lat?: string
    lng?: string
  }
  rftemplate_id?: string
}

export const createOrGetNetworkHome = (
  orgId: string,
  body: createOrGetNetworkHomeBody
) => authorizedNetworkAiFetch.post(`/orgs/${orgId}/sites`, body)

export const fetchOrgAdmins = (orgId: string) =>
  authorizedNetworkAiFetch.get(`/orgs/${orgId}/admins`)

export const inviteOrgAdmins = (orgId: string, body: OrgAdminInvite) =>
  authorizedNetworkAiFetch.post(`/orgs/${orgId}/invites`, body)

export const deleteDomainAdmins = (domainId: string, body: RemoveAdmin) =>
  authorizedNetworkAiFetch.put(`/domains/${domainId}/removeAdmin`, body)

export const getNetworkHome = (orgId: string, bodyId: string) =>
  authorizedNetworkAiFetch.post(`/orgs/${orgId}/sites/${bodyId}`)

export interface claimDeviceBody {
  mac: string
  code: string
  name: string
}

export const claimDevice = (
  orgId: string,
  siteId: string,
  body: claimDeviceBody
) => authorizedNetworkAiFetch.post(`/orgs/${orgId}/sites/${siteId}/claim`, body)

export const fetchClaimDevices = (siteId: string) =>
  authorizedNetworkAiFetch.get(`/sites/${siteId}/devices`)

export const deleteClaimDevice = (orgId: string, mac: string, magic: string) =>
  authorizedNetworkAiFetch.put(`/inventory/${orgId}/claim`, {
    magic,
    mac,
  })

export const createWLAN = (siteId: string, body: CreateWLANBody) =>
  authorizedNetworkAiFetch.post(`/sites/${siteId}/wlans`, body)

export const createSiteWLAN = (siteId: string, body: SiteWlan) =>
  authorizedNetworkAiFetch.post(`/sites/${siteId}/wlans`, body)

export const updateWLAN = (siteId: string, body: UpdateWLANBody) =>
  authorizedNetworkAiFetch.put(`/sites/${siteId}/wlans/${body.id}`, body)

export const enableWLAN = (siteId: string, body: EnableWLANBody) =>
  authorizedNetworkAiFetch.put(`/sites/${siteId}/wlans/${body.id}`, body)

export const deleteWLAN = (siteId: string, wlanId: string) =>
  authorizedNetworkAiFetch.delete(`/sites/${siteId}/wlans/${wlanId}`)

export const fetchSiteWlans = (siteId: string) =>
  authorizedNetworkAiFetch.get(`/sites/${siteId}/wlans`)

export const fetchInventoryOld = (orgId: string) =>
  authorizedNetworkAiFetch.get(`/orgs/${orgId}/inventory`)

export const fetchInventory = (site_id: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}/stats/devices`)

export const fetchSiteClientsCount = (site_id: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}/wired_clients/count`)

export const fetchSiteStats = (site_id: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}/stats`)

export const fetchSiteInfo = (site_id: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}`)

export const fetchSiteDeviceStats = (site_id: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}/stats/devices`)

export const fetchSiteMetric = (
  site_id: string,
  metric: string,
  start: number,
  end: number
) =>
  authorizedNetworkAiFetch.get(
    `/sites/${site_id}/sle/site/${site_id}/metric/${metric}/summary-trend?start=${start}&end=${end}`
  )

export const fetchSiteUptimeMetrics = (site_id: string) =>
  authorizedNetworkAiFetch.get(
    `/sites/${site_id}/insights/site/${site_id}/stats`
  )

export const fetchWLANDetails = (site_id: string, wlanId: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}/wlans/${wlanId}`)

export const fetchSiteClients = (site_id: string) =>
  authorizedNetworkAiFetch.get(`/sites/${site_id}/stats/clients`)

export const fetchOrgRFTemplate = (orgId: string) =>
  authorizedNetworkAiFetch.get(`/orgs/${orgId}/rftemplates`)

export const fetchOrgSiteRFTemplate = (orgId: string, rfTemplateId: string) =>
  authorizedNetworkAiFetch.get(`/orgs/${orgId}/rftemplates/${rfTemplateId}`)

export const updateOrgRFTemplate = (
  orgId: string,
  rfTemplateId: string,
  body: UpdateOrgRFTemplate
) =>
  authorizedNetworkAiFetch.put(
    `/orgs/${orgId}/rftemplates/${rfTemplateId}`,
    body
  )

export const fetchOrgTemplates = (orgId: string) =>
  authorizedNetworkAiFetch.get(`/orgs/${orgId}/template`)

export const createOrgTemplate = (orgId: string, body: OrgTemplates) =>
  authorizedNetworkAiFetch.post(`/orgs/${orgId}/template`, body)

export const deleteOrgTemplate = (orgId: string, body: DeleteOrgTemplate) =>
  authorizedNetworkAiFetch.put(`/orgs/${orgId}/template`, body)

export const fetchOrgSiteWlans = (orgId: string) =>
  authorizedNetworkAiFetch.get(`/orgs/${orgId}/siteWlans`)

export const fetchSitePSKs = (siteId: string) =>
  authorizedNetworkAiFetch.get(`/sites/${siteId}/psks`)

export const createSitePSKs = (siteId: string, body: SitePSKs) =>
  authorizedNetworkAiFetch.post(`/sites/${siteId}/psks`, body)

export const updateSitePSKs = (
  siteId: string,
  pskId: string,
  body: UpdateSitePSKs
) => authorizedNetworkAiFetch.put(`/sites/${siteId}/psks/${pskId}`, body)

export const updateSiteMultiPSKs = (siteId: string, body: [UpdateSitePSKs]) =>
  authorizedNetworkAiFetch.put(`/sites/${siteId}/psks`, body)

export const deleteSitePSKs = (siteId: string, pskId: string) =>
  authorizedNetworkAiFetch.delete(`/sites/${siteId}/psks/${pskId}`)

export const deleteSsidSitePSKs = (siteId: string, ssid: string) =>
  authorizedNetworkAiFetch.delete(`/sites/${siteId}/psks?ssid=${ssid}`)

export const optimizeRadios = (siteId: string, body: OptimizeRadios) =>
  authorizedNetworkAiFetch.post(`/sites/${siteId}/rrm/optimize`, body)
